import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AuthCallbackView from './AuthCallback';
import AuthView from './AuthView';
import LandingView from '../Landing/LandingView';

export default function AuthNavigation() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<LandingView />} />
        <Route path='/auth' element={<AuthView />} />
        <Route path='/auth/callback' element={<AuthCallbackView />} />
        <Route path='*' element={<Navigate to='/' />} />
      </Routes>
    </BrowserRouter>
  );
}
